import React from 'react';
import { Helmet } from 'react-helmet';

function General_FAQ_Seo() {
    return (
        <div>
            <Helmet>
                <title>Frequently Asked Questions | FinestPay</title>
                <meta name="description" content="" />
                <meta property="og:title" content="Frequently Asked Questions | FinestPay" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/frequently-asked-questions"/>
            </Helmet>
        </div>
    )
}

export default General_FAQ_Seo
